var map = {
	"./accessoires/foreground-01.png": "09a0",
	"./accessoires/glasses-01.png": "961f",
	"./accessoires/glasses-02.png": "fe6e",
	"./accessoires/hat-01.png": "9c18",
	"./accessoires/hat-02.png": "8aa2",
	"./accessoires/hat-03.png": "565d",
	"./accessoires/hat-04.png": "09f5",
	"./all_pieces_icon.png": "b93d",
	"./avatar_pieces.png": "a14f",
	"./bot.png": "64cf",
	"./eye.png": "5353",
	"./globulo-stars.png": "f6d7",
	"./graph.png": "5333",
	"./m-0.png": "5dd7",
	"./m-00.png": "286d",
	"./m-1.png": "74d2",
	"./m-2.png": "0490",
	"./m-3.png": "fe46",
	"./mascotte-announcement.png": "4a2c",
	"./mascotte-blind.png": "f5b2",
	"./mascotte-default.png": "fe68",
	"./mascotte-error.png": "72ca",
	"./mascotte-red.png": "5aa0",
	"./mascotte-warning.png": "ab2e",
	"./mascotte-white.png": "b5b8",
	"./user.png": "45b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b1c";